import { actions } from './../actions';

const initialState = [];

export const invitationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_INVITATIONS_SUCCEED:
      return action.payload;
    case actions.DESTROY_INVITATION_SUCCEED:
      return state.filter(i => i.id !== action.payload.id);
    case actions.REINVITE_SUCCEED:
      return state.map(i => {
        return {
          ...i,
          ...(action.payload.id === i.id ? action.payload : {})
        };
      });
    case actions.INVITATION_CHANGE_ACCOUNT_TYPE_SUCCEED:
      return state.map(invitation =>
        invitation.id === action.payload.id ? action.payload : invitation
      );
    default:
      return state;
  }
};
